import React from 'react';
import GithubIcon from 'mdi-react/GithubIcon';
import { Box } from '@material-ui/core';
import clsx from 'clsx';
import '../../styling/Styles.css';
import { Wrapper } from '../../styling/Styles';

/**
 * This component handle githubLogin.
 */

const GitHubLogin = ({ data, setData }) => (
  <>
    <Box mt={1} display="flex">
      <div
        style={{
          fontSize: '0.9vw',
          width: '15vw',
          whiteSpace: 'nowrap'
        }}
        className={('parent', clsx('marginAuto', 'lightBlue'))}
      >
        Login with Github to begin building
      </div>
    </Box>
    <Box display="flex">
      <div
        style={{
          fontSize: '0.9vw',
          width: '15vw',
          whiteSpace: 'nowrap',
          textAlign: 'center'
        }}
        className={('parent', clsx('marginAuto', 'lightBlue'))}
      >
        your perfect app!
      </div>
    </Box>

    <Wrapper style={{ marginTop: '20px' }}>
      {data.errorMessage && (
        <section className="container">
          <span>{data.errorMessage}</span>
        </section>
      )}
      <section className="container">
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <div className="login-container" >
            {data.isLoading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
                <a
                  href={`${process.env.REACT_APP_SERVER_URL}/api/authenticate/loginToGitHub`}
                  onClick={() => {

                    setData({ ...data, isLoading: true });
                  }}
                  style={{
                    backgroundColor: '#e83c52',
                    borderRadius: '8px',
                    borderColor: '#e83c52',
                    borderStyle: 'solid',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'Open Sans',
                    cursor: 'pointer',
                    textDecoration: 'none',
                    justifyContent: 'center',
                    textTransform: 'none',
                    paddingLeft: '0.1rem',
                    paddingRight: '0.1rem',
                    paddingTop: '0.3rem',
                    paddingBottom: '0.3rem'
                  }}
                >
                  <GithubIcon />
                  <span style={{ marginLeft: '5px',fontSize: '1vw' }}>Login </span>
                </a>
            )}
          </div>
        </div>
      </section>
    </Wrapper>
  </>
);

export default GitHubLogin;
